import { z } from "zod";
import { TApiObjectBase, TObjectBase } from "../base";
import { TApiCustomField } from "../customFields/customFields";
import { TTranslationData } from "../common/translation";

export const TRawTaskTypeEnabledFor = z.object({
  roles: z.array(z.number()).optional(),
  tenantTypes: z.array(z.string()).optional(),
});

export const TApiTaskType = z
  .object({
    id: z.string(),
    companyID: z.string(),
    title: TTranslationData,
    enabledFor: TRawTaskTypeEnabledFor.optional(),
    customFields: z.array(TApiCustomField).optional(),
    requiredFields: z.array(z.string()).optional(),
    description: z.string().optional(),
    color: z.string().optional(),
    displayOnSeparatePage: z.boolean().optional(),
  })
  .extend(TApiObjectBase.shape);
export type IApiTaskType = z.infer<typeof TApiTaskType>;

export const TRawTaskType = z
  .object({
    title: TTranslationData,
    enabledFor: TRawTaskTypeEnabledFor.optional(),
    customFieldIDs: z.array(z.string()).optional(),
    requiredFields: z.array(z.string()).optional(),
    description: z.string().optional(),
    color: z.string().optional(),
    displayOnSeparatePage: z.boolean().optional(),
  })
  .extend(TObjectBase.shape);
export type IRawTaskType = z.infer<typeof TRawTaskType>;
